import { render, staticRenderFns } from "./Antraege.vue?vue&type=template&id=da6151ee&scoped=true"
import script from "./Antraege.vue?vue&type=script&lang=ts"
export * from "./Antraege.vue?vue&type=script&lang=ts"
import style0 from "./Antraege.vue?vue&type=style&index=0&id=da6151ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6151ee",
  null
  
)

export default component.exports